import {Injectable} from "@angular/core";
import {Preferences} from "@capacitor/preferences";

const webStorageKeys = [
  'authToken',
  'lastRefresh',
  'lastSelectedFarmReference',
  'locationAgeFilterPeriod',
  'preferences',
  'user',
]

@Injectable({providedIn: 'root'})
export class WebStorageService {
  
  //These are all related to semi-persistent data.
  //They are the only semi-persistent storage functions available in a web environment.
  // They should not be used on native devices, since native devices randomly can clean their local storage.
  async store<T>(key: string, value?: T) {
    return await Preferences.set({key: key, value: JSON.stringify(value)})
  }
  
  async getStored<T>(key: string): Promise<T | undefined> {
    const result = await Preferences.get({key: key})
    return result.value != undefined ? JSON.parse(result.value) : undefined
  }
  
  async hasStored(key: string): Promise<boolean> {
    const result = await Preferences.keys()
    return result.keys.includes(key)
  }
  
  async removeStored(key: string) {
    this.hasStored(key).then((hasKey: boolean) => {
      if (hasKey) {
        return Preferences.remove({key: key})
      }
      return Promise.resolve()
    })
  }
  
  shouldStore(key: string): boolean {
    return webStorageKeys.includes(key)
  }
}